import styled from '@emotion/styled'

// eslint-disable-next-line import/prefer-default-export
export const IframeWrapper = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  iframe {
    max-width: ${({ width }) => (width ? `${width}px` : 'auto')};
    min-width: 100%;
    max-height: ${({ height }) => (height ? `${height}px` : 'auto')};
    min-height: 100%;
  }
`
export const Video = styled.div`
  width: 100%;
`
